module.exports = __webpack_public_path__ + "img/iconhuishou.a1ece93b.png";